import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserInfo = {
  filters: any;
  handleFilters: (data: any) => void;
};

/**
 * State Management for Test Records
 * @dynamic
 * @hook {function}
 */
export const useInfo = create(
  persist<UserInfo>(
    set => ({
      filters: null,
      handleFilters: (data: any) => {
        set(() => ({
          filters: data,
        }));
      },
      clearAll: () =>
        set({
          filters: null,
        }),
    }),
    {
      name: "useInfo-storage",
    }
  )
);
